import { Action } from '@ngrx/store';
import {
  datasetRefreshFromContextMenu,
  datasetRefreshFromDatasetTab,
  datasetRefreshFromQueryNavContextMenu,
  datasetRefreshFromSideBar,
} from './imported-dataset.actions';

export abstract class ImportedDatasetFacade {
  static Actions = {
    datasetRefreshFromContextMenu,
    datasetRefreshFromQueryNavContextMenu,
    datasetRefreshFromDatasetTab,
    datasetRefreshFromSideBar,
  };
  abstract dispatch(action: Action): void;
}
